import { httpCreate } from './http';

const http = httpCreate('/srv/gather-statistics/');

export const gatherStatistics = {
	// 获取合集数据
	getStatistics(albumId, params) {
		return http.get(`/${albumId}`, { params });
	},
	// 获取在线人数折线图
	getOnlineNum(albumId, params) {
		return http.get(`/online/chart/${albumId}`, { params });
	},
	// 获取访问量
	getLineChart(albumId, params) {
		return http.get(`/getLineChart/${albumId}`, { params });
	},
	// 获取合集参与数和观看时长
	getDurationById(gatherId) {
		return http.get(`/totalTime/${gatherId}`);
	},
};
